<template>
  <section class="hero is-fullheight" style="height: auto !important;">
    <ClientBody :PCTRLLOG="CTRLLOG" />
  </section>
</template>

<script>
import ClientBody from '@/views/Client/ClientBody'
import controlLogMixin from '@/mixins/controlLogMixin'
import createUUID from '@/functions/createUUID'
export default {
  name: 'Client',
  components: {
    ClientBody
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      COMPONENT_NAME: 'Client'
    }
  },
  mounted () {
    //アクセスに関する操作履歴
    this.$store.commit('auth/setControlLogViewID', createUUID())
    this.sendControlLogRelatedUsage('HRモンスターアクセス', 'HRモンスターの管理ページを開いた')
    document.addEventListener('visibilitychange', this.updateVisibility)
    window.addEventListener('beforeunload', this.onBeforeUnload)
  },
  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.updateVisibility)
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  methods: {
    updateVisibility () {
      if (document.visibilityState === 'visible') {
        this.sendControlLogRelatedUsage('HRモンスター再表示', 'HRモンスターのウインドウにフォーカスが移動した')
      }
      else {// hidden
        this.sendControlLogRelatedUsage('HRモンスター非表示', 'HRモンスター以外のウインドウにフォーカスが移動した')
      }
    },
    onBeforeUnload() {
      this.sendControlLogRelatedUsage('HRモンスター離脱', 'HRモンスターの管理ページを閉じた')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Client/Client.vue